import {
  styled as muiStyled,
  FormGroup,
  FormControlLabel,
  Typography,
  Checkbox,
  Stack,
} from '@mui/material';
import { COLORS } from '../../../../../../themes/colors';

export const FormGroupStyled = muiStyled(FormGroup)(props => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: props.infinityList ? 'start' : 'space-between',
  alignSelf: 'flex-start',
  marginBottom: props.infinityList ? '12px' : '0',
}));

export const FormLabelStyled = muiStyled(FormControlLabel)(() => ({
  color: `${COLORS.DARK['+3']}`,
}));

export const CheckboxStyled = muiStyled(Checkbox)(() => ({
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  padding: '7px',
  '&.Mui-checked': {
    color: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const LabelStyled = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
  color: `${COLORS.DARK['+5']}`,
}));

export const StackStyled = muiStyled(Stack)(() => ({
  flexDirection: 'column',
}));

export const TitleStyled = muiStyled(Stack)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
  color: `${COLORS.DARK['+5']}`,
  maxWidth: '176px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'block',
}));

export const DescriptionStyled = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '12px',
  color: `${COLORS.GRAY['-9']}`,
}));
